import { useEffect, useRef, type ReactNode } from 'react';
import { HomeDialog } from './home/HomeDialog';

export interface AlertAction { label: string; onSelect: () => void; busy?: boolean }

/**
 * The Figma «Alert · Delete floor»: a title, a line and its actions, the black one last and focused, so Enter takes it;
 * Escape and ✕ take `onClose`. A busy action keeps its focus and its size and takes no press.
 */
export function Alert({ title, text, spinner = false, primary, secondary, onClose, className = '' }: {
  title: string; text: ReactNode; spinner?: boolean; primary?: AlertAction; secondary?: AlertAction; onClose: () => void; className?: string;
}) {
  const focused = useRef<HTMLButtonElement>(null);
  // After the dialog's own showModal, which focuses its first control, the ✕.
  useEffect(() => { focused.current?.focus(); }, []);
  const button = (action: AlertAction, kind: 'primary' | 'secondary', focus: boolean) =>
    <button type="button" ref={focus ? focused : undefined} className={'alert-button ' + kind} aria-disabled={action.busy || undefined} aria-busy={action.busy || undefined}
      onClick={() => { if (!action.busy) action.onSelect(); }}>
      {action.busy && <span className="alert-button-spinner" aria-hidden="true" />}<span>{action.label}</span>
    </button>;
  return <HomeDialog title={title} onClose={onClose} className={`session-alert ${className}`.trim()} backdropDismiss={false} role="alertdialog">
    {spinner && <span className="alert-spinner" aria-hidden="true" />}
    <p role={spinner ? 'status' : undefined}>{text}</p>
    <div className="alert-actions">
      {secondary && button(secondary, 'secondary', !primary)}
      {primary && button(primary, 'primary', true)}
    </div>
  </HomeDialog>;
}
